import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useGlobalContext } from "./data/GlobalContext"
const LiveChat = () => {
  const { username } = useGlobalContext()
  const location = useLocation()

  useEffect(() => {
    // Initialize LiveChat widget
    window.__lc = window.__lc || {}
    window.__lc.license = 11142882
    ;(function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n)
      }
      const e = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function () {
          i(["on", c.call(arguments)])
        },
        once: function () {
          i(["once", c.call(arguments)])
        },
        off: function () {
          i(["off", c.call(arguments)])
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            )
          return i(["get", c.call(arguments)])
        },
        call: function () {
          i(["call", c.call(arguments)])
        },
        init: function () {
          const s = t.createElement("script")
          s.async = true
          s.type = "text/javascript"
          s.src = "https://cdn.livechatinc.com/tracking.js"
          t.head.appendChild(s)
        },
      }

      if (!n.__lc.asyncInit) e.init()
      n.LiveChatWidget = n.LiveChatWidget || e
    })(window, document, [].slice)

    // Wait until widget is fully ready
    window.LiveChatWidget.on("ready", function () {
      const updateZIndex = (value) => {
        const chatWidget = document.querySelector("#chat-widget-container")
        if (chatWidget) {
          chatWidget.style.zIndex = value
          // console.log(`[DEBUG] Set z-index to ${value}`)
        }
      }

      if (username) {
        window.LiveChatWidget.call("set_customer_name", username)
      }

      // Initial setup
      window.LiveChatWidget.call("minimize")
      updateZIndex("99")

      let isChatOpen = false // Move this outside so it persists
      window.LiveChatWidget.on("visibility_changed", function (data) {
        if (data.visibility === "maximized") {
          updateZIndex("9999")
          // console.log("[DEBUG] Chat maximized – z-index set to 9999")
        } else if (data.visibility === "minimized") {
          updateZIndex("99")
          // console.log("[DEBUG] Chat minimized – z-index set to 999")
        }
      })
      const initInternalToggle = () => {
        const getBtn = document.querySelector(
          `aria-label="Open LiveChat chat widget"`
        )

        if (getBtn) {
          getBtn.addEventListener("click", (e) => {
            e.preventDefault()
            if (isChatOpen) {
              window.LiveChatWidget.call("minimize")
              // console.log("[DEBUG] Chat minimized via internal button")
            } else {
              window.LiveChatWidget.call("maximize")
              // console.log("[DEBUG] Chat maximized via internal button")
            }
            isChatOpen = !isChatOpen // 💥 Toggle it correctly
          })
        } else {
          // Retry after slight delay if button not ready yet
          setTimeout(initInternalToggle, 500)
        }
      }

      // Custom nav button toggle
      setTimeout(() => {
        const chatButtons = document.querySelectorAll(".nav-item-chat-support")
        chatButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault()
            if (isChatOpen) {
              window.LiveChatWidget.call("minimize")
              console.log("[DEBUG] Chat minimized via nav button")
            } else {
              window.LiveChatWidget.call("maximize")
              console.log("[DEBUG] Chat maximized via nav button")
            }
            isChatOpen = !isChatOpen
          })
        })
      }, 1000)
    })

    // Clean up script on route change
    return () => {
      const script = document.querySelector(
        'script[src="https://cdn.livechatinc.com/tracking.js"]'
      )
      if (script) {
        script.remove()
      }
      delete window.LiveChatWidget
    }
  }, [location, username])

  return null
}

export default LiveChat
